import * as React from 'react';
var IntlContext = React.createContext(null);
if (process.env.NODE_ENV !== 'production') {
    IntlContext.displayName = 'IntlContext';
}
export { IntlContext };
